import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c(VMain,[_c('snackbar'),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.routing),expression:"!routing"}]})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }